import without from 'lodash/without';
import times from 'lodash/times';
import uniq from 'lodash/uniq';
import shuffle from 'lodash/shuffle';
import get from 'lodash/get';
import sample from 'lodash/sample';
import random from 'lodash/random';
import moment from 'moment';
import Pusher from 'pusher-js';
import 'moment-duration-format';
import Reel from '../groups/Reel';
import { TILE_WIDTH, TILE_HEIGHT, SPACING } from '../constants';
import ValueTweener from '../ValueTweener';
import FlipCounter from '../FlipCounter';
import Counter from '../groups/Counter';
import Lock from '../Lock';
import { calculateRemainingTime } from '../utils';
import Debug from '../Debug';
import '../filters/Gray';
import State from '../State';
import MessageBoard from '../MessageBoard';

const { Linear } = window;

const SPIN_DELAY = 0.25;
const SYMBOLS = ['aleague', 'nba', 'nrl', 'odi', 'chest'];
const NUM_REELS = 3;
function randomMiddleLine() {
  const firstPick = sample(SYMBOLS);
  // 50% chance of 2nd pick being same as first to make users think they could win
  const secondPick = Math.random() > 0.5 ? firstPick : sample(SYMBOLS);
  const lastPick = sample(without(SYMBOLS, firstPick));
  return [firstPick, secondPick, lastPick];
}

function generateAnticipationDelay() {
  return random(2, 4, true);
}

function getSportFromAmount(amount) {
  return {
    0: null,
    10: 'aleague',
    50: 'odi',
    100: 'nba',
    500: 'nrl',
  }[amount];
}

export default class extends State {
  jackpotAmount = 0;
  winnings = 0;
  valueTweener = new ValueTweener();

  create() {
    const { isDesktop, spinsRemaining } = this.game.props;
    this.isLocked = spinsRemaining === 0;
    this.grayFilter = this.add.filter('Gray');
    this.bmds = [];
    // this.addBackground();
    if (isDesktop) this.addBackCoins();
    this.addJackpot();

    this.slotsGrp = this.add.group(this.world, 'full-reel-group');
    this.slotsGrp.position.x = isDesktop ? 100 : 10;
    this.slotsGrp.position.y = 170;

    this.addSlots(this.slotsGrp);

    this.messageBoard = new MessageBoard(
      this.game,
      isDesktop ? 165 : 75,
      137,
      new Phaser.Rectangle(0, 0, 550, 100),
      {
        queue: [
          'welcome to spin and win',
          'over 35,000 bonus PlayChips won on the opening weekend!',
          'Thousands of bonus PlayChips given away every day!',
          'every 5 spins adds 1 playchip to the jackpot',
          '^^ jackpot is ticking up ^^',
        ],
        frameRate: 60,
        speed: 1.3,
      },
    );
    this.world.addChild(this.messageBoard);

    if (isDesktop) this.addFrontCoins();

    this.initPusher();

    this.game.signals.componentDidUpdate.add(this.componentDidUpdate, this);
    this.componentDidUpdate({});

    if (Debug.config.fps) {
      this.game.time.advancedTiming = true;
      this.fpsTxt = this.game.add.text(50, 20, this.game.time.fps || '--', {
        font: '24px Arial',
        fill: '#00ff00',
      });
    }

    if (Debug.config.text) {
      this.debugTxt = this.game.add.text(50, 20, '--', {
        font: '24px Arial',
        fill: '#00ff00',
      });
    }

    // window.Game = this;
    // this.animateCoinParticles(10);
    super.create();
  }

  update() {
    if (Debug.config.fps) {
      this.fpsTxt.text = this.game.time.fps; // debug text doesn't work with the canvas renderer??
      this.fpsTxt.bringToTop();
    }
  }

  shutdown() {
    this.cleanupPusher();

    while (this.bmds.length > 0) {
      this.bmds.pop().destroy();
    }
    this.killAllTweens();
    if (this.interval) window.clearInterval(this.interval);
    if (this.timer) window.clearInterval(this.timer);
  }

  componentDidUpdate(prevProps) {
    // console.log('old props', prevProps, 'new props', this.game.props);
    if (prevProps.isPosting === true && this.game.props.isPosting === false) {
      this.handleReceivedResult(this.game.props.winAmount);
    }
    // if (prevProps.jackpot !== this.game.props.jackpot) {
    //   this.counter.flipToNumber(this.game.props.jackpot);
    // }
    if (prevProps.spinsRemaining !== this.game.props.spinsRemaining) {
      this.spinCounter.setNumber(this.game.props.spinsRemaining);
    }
    if (prevProps.spinsRemaining === 0 && this.game.props.spinsRemaining >= 1) {
      // show unlocked
      this.unlockSlots();
    }
    const locked = this.game.props.spinsRemaining === 0;
    if (prevProps.showModal && !this.game.props.showModal) {
      if (locked) {
        // show locked
        this.lockSlots();
      } else {
        this.enableCrank();
      }
    }

    if (prevProps.winners !== this.game.props.winners) {
      this.messageBoard.queue = [
        ...this.messageBoard.queue,
        ...this.game.props.winners
          .filter(winner => winner.user.name.search(/([a-zA-Z_-])\w+/g) !== -1) // bitmaptext only supports alphanumeric
          .map((winner) => {
            if (winner.amount === 500) {
              return `BIG WIN! @${winner.user.name} won a massive ${
                winner.amount
              } bonus playchips!`;
            }
            return `@${winner.user.name} from ${winner.user.country.name} won ${
              winner.amount
            } bonus playchips!`;
          }),
      ];
      this.messageBoard.shuffleQueue();
      this.messageBoard.animate();
    }

    if (this.jackpotAmount === 0) {
      this.jackpotAmount = this.game.props.initialJackpotAmount;
      this.counter.flipToNumber(this.jackpotAmount);
    }
  }

  initPusher() {
    this.pusherSocket = new Pusher('ec6343b4940e9df1aa0e', {
      cluster: 'ap1',
      encrypted: true,
    });

    this.pusherChannel = this.pusherSocket.subscribe('jackpot_slot');

    this.pusherChannel.bind('jackpot_amount_update', (data) => {
      this.jackpotAmount = data.amount;
      this.counter.flipToNumber(this.jackpotAmount);
    });
  }

  cleanupPusher() {
    this.pusherChannel.unbind('jackpot_amount_update');
    this.pusherSocket.unsubscribe('my-channel');
  }

  addBackground() {
    const rect = this.add.graphics(0, 0);
    rect.beginFill(0xff0000, 0.2);
    rect.drawRect(0, 0, this.world.width, this.world.height);
  }

  addJackpot() {
    const { isDesktop, jackpot } = this.game.props;
    const x = isDesktop ? 280 : 180;
    const y = 0;
    this.add.image(x, y, 'jackpot');
    this.counter = this.game.plugins.add(FlipCounter, {
      numDigits: 7,
      startNumber: 0,
    });
    const counterGrp = this.counter.getDisplayGroup();
    counterGrp.position.set(x + 23, y + 64);
  }

  addSlots(parent) {
    const { isDesktop, spinsRemaining } = this.game.props;
    const locked = spinsRemaining === 0;

    const w = (TILE_WIDTH + SPACING) * NUM_REELS;
    const h = 263;

    const REEL_Y = -70;

    this.addReelBg(parent, 40, 10);

    // add backing
    const backing = this.addBacking(parent, 0, -55);

    if (isDesktop) {
      this.addDesktopButton(this.slotsGrp);
    } else {
      this.addMobileButton(this.slotsGrp);
    }

    if (locked) this.disableCrank(true);

    this.reelGrp = this.add.group(parent, 'reel-group');
    this.reelGrp.position.set(56, REEL_Y);

    this.winTxt = this.addWinAmount(parent);

    if (locked) {
      this.addLock(parent);
    } else {
      this.reels = times(NUM_REELS).map(i =>
        this.addReel(`reel${i}`, this.reelGrp, 10 + i * (TILE_WIDTH + SPACING), 0));

      // add splitters
      this.splitters = [
        this.add.image(225, 22, 'assets', 'splitter_left', parent),
        this.add.image(408, 22, 'assets', 'splitter_right', parent),
      ];

      // add shadows
      const shadowBmd = this.makeReelShadowBmd();
      this.addReelShadow(parent, 50, 10, shadowBmd);
      const bottomShadow = this.addReelShadow(parent, 50, backing.height - 75, shadowBmd);
      bottomShadow.scale.y = -1;
      backing.bringToTop();

      // add mask
      const rect = this.add.graphics(0, 10 - REEL_Y);
      rect.beginFill(0xff0000, 0.5);
      rect.drawRect(0, 0, w, h);
      this.reelGrp.addChild(rect);
      this.reelGrp.mask = rect;
    }

    this.spinCounter = new Counter(this.game, spinsRemaining, {
      style: { size: 44, font: 'digital_red' },
      numDigits: 2,
      spacing: 20,
    });
    this.spinCounter.position.set(backing.width - 41, 117);
    parent.addChild(this.spinCounter);
  }

  addWinAmount(parent) {
    const { isDesktop } = this.game.props;

    const grp = this.game.add.group(parent);

    const x = isDesktop ? 400 : 50;
    const y = isDesktop ? 290 : 300;

    grp.position.set(x, y);

    const winBox = this.game.add.image(0, 0, 'assets', 'win-box', grp);

    const currencyGrp = this.game.add.group(grp);
    currencyGrp.position.set(winBox.width / 2, winBox.height / 2 - 6);

    const currencySprite = this.game.add.sprite(0, 0, 'particle', null, currencyGrp);
    currencySprite.anchor.set(0.5);
    currencySprite.scale.set(0.5);
    const anim = currencySprite.animations.add(
      'particle',
      Phaser.Animation.generateFrameNames('particle', 1, 33, '', 4),
      30,
      true,
    );
    anim.play();
    const txt = this.game.add.bitmapText(20, 0, 'panton_white_extrabold', '0', 30, currencyGrp);
    txt.anchor.y = 0.5;

    currencyGrp.pivot.x = currencyGrp.width / 2;

    grp.updateText = (winAmount) => {
      txt.text = winAmount;
      currencyGrp.pivot.x = currencyGrp.width / 2;
    };
    return grp;
  }

  disableCrank(greyOut = false) {
    if (greyOut) this.crank.filters = [this.grayFilter];
    this.crank.inputEnabled = false;
    this.crank.input.useHandCursor = false;
    this.highlight.visible = false;
  }

  enableCrank() {
    this.crank.filters = null;
    this.crank.inputEnabled = true;
    this.crank.input.useHandCursor = true;
    this.highlight.visible = true;
  }

  addDesktopButton(parent) {
    this.add.image(parent.width - 22, 50, 'crank_piece', null, parent);
    this.crank = this.addCrank(parent, parent.width - 12, -75);
    this.highlight = this.addCrankHighlight(parent, parent.width - 71, -22);
  }

  addMobileButton(parent) {
    const x = parent.width - 170;
    const y = 300;
    this.highlight = this.addRedButtonHighlight(parent, x, y + 62);
    this.crank = this.addRedButton(parent, x, y);
  }

  addLock(parent) {
    this.game.physics.startSystem(Phaser.Physics.P2JS);
    this.game.physics.p2.gravity.y = 1200;

    this.lockGrp = this.add.group(parent);
    this.addLockText(this.lockGrp);

    this.lock = this.game.plugins.add(Lock, {
      parent: this.lockGrp,
    });
  }

  addAndTransitionInLock() {
    this.addLock(this.slotsGrp);
    this.tweenMax().from(this.lockGrp, 1, { alpha: 0 });
  }

  transitionToLockedScreen() {
    this.tweenMax().to([this.reelGrp, ...this.splitters], 1, {
      alpha: 0,
      delay: 2,
      onComplete: this.addAndTransitionInLock,
      onCompleteScope: this,
    });
  }

  addLockText(parent) {
    const { unlockTime } = this.game.props;
    const x = 315;
    const txt = this.game.add.text(
      x,
      70,
      'FREE SPIN IN',
      {
        font:
          '26px "Avenir",-apple-system, "BlinkMacSystemFont", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fill: '#12232b',
        align: 'center',
      },
      parent,
    );
    txt.anchor.set(0.5, 0);
    if (unlockTime) {
      const style = { size: 64, font: 'digital_red' };
      this.timeTxt = this.game.add.bitmapText(x, 100, style.font, '00:00:00', style.size, parent);
      this.timeTxt.anchor.set(0.5, 0);
      this.timer = setInterval(() => {
        const remainingTime = calculateRemainingTime(unlockTime);
        if (remainingTime <= 0) {
          this.handleFreeSpinTime();
        }
        this.setTime(remainingTime);
      }, 1000);
      this.setTime(calculateRemainingTime(unlockTime));
    }
  }

  handleFreeSpinTime(parent) {
    const { isDesktop, onFreeSpinTime } = this.game.props;
    window.clearInterval(this.timer);
    this.timer = null;
    this.timeTxt.destroy();
    // check if new spins are here. give it another second to ensure backend is up to date.
    this.tweenMax().delayedCall(1, () => {
      onFreeSpinTime();
    });
    this.addLoader(parent, isDesktop ? this.world.centerX - 60 : this.world.centerX - 30, 320);
  }

  addLoader(parent, x, y) {
    const lineWidth = 4;
    const r = 20;
    const d = r * 2 + lineWidth;
    const bmd = this.make.bitmapData(d, d);
    const { ctx } = bmd;
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = '#ee3032';
    ctx.beginPath();
    ctx.arc(r + lineWidth / 2, r + lineWidth / 2, r, 0, Phaser.Math.degToRad(270));
    ctx.stroke();
    const img = this.add.image(x, y, bmd, null, parent);
    img.anchor.set(0.5);
    this.tweenMax().to(img, 1, { angle: 360, repeat: -1, ease: Linear.easeNone });
    return img;
  }

  unlockSlots() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
    this.game.physics.p2.clear();
    this.lock.destroy();
    this.lock = null;
    this.lockGrp.destroy();
    this.lockGrp = null;
    this.crank.destroy();
    this.crank = null;
    this.slotsGrp.removeChildren();
    this.addSlots(this.slotsGrp);
  }

  lockSlots() {
    this.slotsGrp.removeChildren();
    this.addSlots(this.slotsGrp);
  }

  setTime(remaining) {
    const duration = moment.duration(remaining, 'seconds');
    this.timeTxt.text = duration.format('hh:mm:ss', { trim: false });
  }

  addCrankHighlight(parent, x, y) {
    const d = 70;
    const lineThickness = 10;
    const graphics = this.make.graphics(0, 0);
    graphics.lineStyle(lineThickness, 0xe51a27);
    graphics.drawEllipse(0, 0, d, d);

    const texture = graphics.generateTexture();
    //  Then generate a texture from it and apply the texture to the sprite
    const sprite = this.add.sprite(x, y, texture, null, parent);
    sprite.anchor.set(0.5);
    sprite.scale.set(0.7);
    this.tweenMax().to(sprite.scale, 1, { x: 1, y: 1, repeat: -1 });
    this.tweenMax().to(sprite, 1, { alpha: 0, repeat: -1 });
    return sprite;
  }

  addRedButtonHighlight(parent, x, y) {
    const sprite = this.add.sprite(x, y, 'red_button', 'highlight', parent);
    sprite.anchor.set(0.5);
    sprite.scale.set(1.5);

    this.tweenMax().to(sprite.scale, 1, { x: 2, y: 2, repeat: -1 });
    this.tweenMax().to(sprite, 1, { alpha: 0, repeat: -1 });
    return sprite;
  }

  addReelBg(parent, x, y) {
    const w = (TILE_WIDTH + SPACING) * 3;
    const h = 260;
    const bmd = this.make.bitmapData(w, h);
    this.addBmd(bmd);
    const ctx = bmd.ctx;
    const img = this.game.cache.getImage('bg_reel_tile');
    const pat = ctx.createPattern(img, 'repeat');
    ctx.rect(0, 0, w, h);
    ctx.fillStyle = pat;
    ctx.fill();
    return this.add.image(x, y, bmd, null, parent);
  }

  makeReelShadowBmd() {
    const w = (TILE_WIDTH + SPACING) * 3;
    const h = 48;
    const bmd = this.make.bitmapData(w, h);
    this.addBmd(bmd);
    const ctx = bmd.ctx;
    const img = this.game.cache.getImage('shadow');
    const pat = ctx.createPattern(img, 'repeat');
    ctx.rect(0, 0, w, h);
    ctx.fillStyle = pat;
    ctx.fill();
    return bmd;
  }

  addReelShadow(parent, x, y, bmd) {
    return this.add.image(x, y, bmd, null, parent);
  }

  addWin(amount) {
    this.valueTweener.tweenFromTo(
      2,
      this.winnings,
      this.winnings + amount,
      (value) => {
        this.winTxt.updateText(Math.floor(value));
      },
      this,
      { delay: 2 },
    );
    this.winnings += amount;
  }

  handleReceivedResult(winAmount) {
    // console.log('handleReceivedResult', winAmount);
    const winner = winAmount > 0;
    const sport = getSportFromAmount(winAmount);
    const middleLine = winner ? times(NUM_REELS).map(() => sport) : randomMiddleLine();
    const result = times(NUM_REELS).map(i => [sample(SYMBOLS), middleLine[i], sample(SYMBOLS)]);
    if (this.spinTl.isActive()) {
      this.spinTl.call(this.stop, [result, winAmount], this);
    } else {
      this.stop(result, winAmount);
    }
  }

  spin() {
    this.game.props.onSpin();
    this.disableCrank();
    this.game.add.audio('click').play();
    this.spinSnd = this.game.add.audio('spin', 1, true);
    this.spinSnd.play();

    const tl = this.timelineMax();
    this.reels.forEach((reel, i) => tl.call(reel.spin, [], reel, i * SPIN_DELAY));
    tl.call(this.spinComplete, [], this, 2);
    this.spinTl = tl;
  }

  spinComplete() {}

  hasLongDelay(results) {
    return results[0][1] === results[1][1];
  }

  stop(results, winAmount) {
    const { spinsRemaining } = this.game.props;
    const locked = spinsRemaining === 0;
    // console.log('stop', results);
    this.crank.animations.play('up');
    if (locked) this.disableCrank(true);
    const delays = [
      0,
      SPIN_DELAY * 2,
      this.hasLongDelay(results) ? generateAnticipationDelay() : SPIN_DELAY * 4,
    ];
    this.tweenMax().delayedCall(delays[2] - 0.5, () => {
      if (winAmount > 0) {
        this.game.add.audio('super_success').play();
      } else {
        this.game.add.audio('reaction').play();
      }
    });
    const promises = this.reels.map((reel, i) =>
      new Promise(resolve =>
        this.tweenMax().delayedCall(delays[i], () => {
          reel.requestStop(results[i], () => {
            const uniqLength = uniq(times(i + 1).map(j => results[j][1])).length;
            if (uniqLength === 1) {
              this.game.add.audio('select').play();
            } else {
              this.game.add.audio('stick').play();
            }
            resolve();
          });
        })));
    Promise.all(promises).then(() => this.handleSpinsComplete(winAmount));
  }

  handleSpinsComplete(winAmount) {
    this.spinSnd.stop();
    const winner = winAmount > 0;
    if (winner) {
      this.game.add.audio('success').play();
      this.animateCoinParticles(Math.min(50, winAmount));
      this.addWin(winAmount);
      this.reels.forEach(reel => reel.glow());
      this.tweenMax().delayedCall(1, () => {
        this.handleSpinsReallyComplete(winner);
        this.game.props.onSpinComplete();
      });
    } else {
      this.handleSpinsReallyComplete(winner);
      this.game.props.onSpinComplete();
    }
  }

  handleSpinsReallyComplete(winner) {
    const { spinsRemaining } = this.game.props;
    if (spinsRemaining === 0) {
      this.transitionToLockedScreen();
    } else {
      this.enableCrank();
    }
  }

  makeAmounts(amount) {
    const arr = [];
    let count = 0;
    const increment = Math.floor(amount / 3);
    for (let i = 0; i < this.reels.length; i++) {
      if (i === this.reels.length - 1) {
        arr.push(amount - count);
      } else {
        arr.push(increment);
        count += increment;
      }
    }
    return arr;
  }

  animateCoinParticles(winAmount) {
    const { isDesktop } = this.game.props;
    const frameNames = Phaser.Animation.generateFrameNames('particle', 1, 33, '', 4);
    const amounts = this.makeAmounts(winAmount);
    this.reels.forEach((reel, j) => {
      const x = reel.x + (isDesktop ? 200 : 160);
      const y = 220;
      const targetX = isDesktop ? 640 : 130;
      const targetY = 450;
      const halfX = x + (targetX - x) / 2;
      const halfY = y + (targetY - y) / 2;
      for (let i = 0; i < amounts[j]; i++) {
        const coin = this.game.add.sprite(x + TILE_WIDTH / 2, y + TILE_HEIGHT / 2, 'particle');
        const anim = coin.animations.add('particle', frameNames, 30, true);
        anim.play();
        anim.frame = random(0, 32);
        coin.anchor.set(0.5);
        coin.scale.set(random(0.5, 1));
        coin.rotation = random(0, Phaser.Math.PI2);
        coin.alpha = 0;
        const tl = new TimelineMax({ delay: i * 0.05 + random(0, 0.1) });
        tl
          .to(coin, 0.1, { alpha: 1 })
          .to(
            coin,
            1.2,
            {
              ease: Quad.easeInOut,
              bezier: {
                values: [
                  { x, y },
                  { x: halfX + random(-150, 150), y: halfY + random(-150, 150) },
                  { x: targetX, y: targetY },
                ],
                type: 'quadratic',
              },
            },
            0,
          )
          .to(
            coin.scale,
            0.6,
            { x: coin.scale.x * 2, y: coin.scale.x * 2, ease: Quad.easeInOut },
            0,
          )
          .to(
            coin.scale,
            0.6,
            {
              x: coin.scale.x * 0.5,
              y: coin.scale.x * 0.5,
              ease: Quad.easeInOut,
            },
            0.6,
          )
          .to(coin, 0.3, { alpha: 0 }, '-=0.3');
        tl.timeScale(0.6);
      }
    });
  }

  /* -------------------------------------------------------
    -- PRIVATE
    ------------------------------------------------------- */

  addReel(key, parent, x, y) {
    const reel = new Reel(this.game, key, SYMBOLS);
    reel.position.set(x, y);
    parent.addChild(reel);
    return reel;
  }

  addBacking(parent, x, y) {
    const reel = this.add.image(x, y, 'reel', null, parent);
    return reel;
  }

  addCrank(parent, x, y) {
    const sprite = this.make.sprite(x, y, 'crank', 'up');
    parent.addChildAt(sprite, 0);
    sprite.animations.add('down', ['up', 'middle', 'down'], 30, false, false);
    sprite.animations.add('up', ['down', 'middle', 'up'], 30, false, false);
    sprite.inputEnabled = true;
    sprite.input.useHandCursor = true;
    sprite.events.onInputUp.add(() => {
      this.highlight.visible = false;
      sprite.animations.play('down').onComplete.addOnce(this.spin, this);
    });
    return sprite;
  }

  addRedButton(parent, x, y) {
    const sprite = this.add.sprite(x, y, 'red_button', 'button_up', parent);
    sprite.animations.add('down', [1, 0]);
    sprite.animations.add('up', [0, 1]);
    sprite.anchor.set(0.5, 0);
    sprite.inputEnabled = true;
    sprite.input.useHandCursor = true;
    sprite.events.onInputUp.add(() => {
      this.highlight.visible = false;
      sprite.animations.play('down');
      this.spin();
    });
    return sprite;
  }

  addBackCoins() {
    const { isDesktop } = this.game.props;
    const x = isDesktop ? 40 : 0;
    const y = isDesktop ? 300 : 200;
    this.add.image(x, y, 'assets', 'back_coins');
  }

  addFrontCoins() {
    const { isDesktop } = this.game.props;
    const x = isDesktop ? 10 : 10;
    const y = isDesktop ? 400 : 300;
    this.add.image(x, y, 'assets', 'front_coins');
  }

  addBmd(bmd) {
    this.bmds.push(bmd);
  }
}
